import { FaUserFriends, FaWallet } from "react-icons/fa";
import DashboardLayout from "../Layout/Index";
import Barchart from "../charts/Bar-chart";
import Piechart from "../charts/Pie-chart";
import Card from "../components/Card";
import OverviewCard from "../components/OverviewCard";
import OverviewTable from "../components/tables/OverviewTable";
import { IoMdBicycle } from "react-icons/io";
import { useEffect } from "react";
import { fetchOverview } from "../redux/slices/overviewSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Overview() {
  const dispatch = useDispatch()

  const overview = useSelector((state) => state.overview)

  useEffect(() =>{
    dispatch(fetchOverview())
  }, [dispatch])

  const overviewData = overview?.overview?.data

  return (
    <DashboardLayout>
      <div className="p-6 sm:p-8 bg-[#F9F9F9] mt-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-1">
          <Card
            img={<FaWallet className="text-white" />}
            title="Total Daily Sale Amount"
            amount={overviewData?.dailySalesAmount}
            percent={overviewData?.salesWeeklyIncreasePercentage}
            date="Weekly"
            bgColor="red"
            icon="icon"
          />
          <Card
            className="bg-white text-black"
            img={<FaWallet />}
            title="Total Balance"
            amount={overviewData?.totalSalesAmount}
            date="Transaction History"
          />
          <OverviewCard
            className="bg-white text-black"
            img={<FaUserFriends />}
            title="Total Registered Customers"
            amount={overviewData?.registeredCustomers}
            percent={overviewData?.weeklyCustomerIncreasePercentage}
            date="Weekly"
            icon="icon"
          />
          <OverviewCard
            className="bg-white text-black"
            img={<IoMdBicycle/>}
            title="Active Delivery Agents"
            amount={overviewData?.activeDeliveryAgents}
            percent={overviewData?.monthlyIncreasePercentage}
            date="Month"
            icon="icon"
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 mt-6 gap-4">
          <div className="p-3 rounded-md bg-white">
            <Barchart 
              order={overviewData?.orderMetrics}
            />
          </div>
          <div className="p-3 rounded-md bg-white ">
            <Piechart
              transaction={overviewData?.transactionsMetrics}
            />
          </div>
        </div>
        <OverviewTable recentOrder={overviewData?.recentOrders} />
      </div>
    </DashboardLayout>
  )
}